const skuToIgnoreCOD = [
    "40514275541164",
    "40544767017132",
    "40544805978284",
    "40544832782508",
    "40546550415532",
    "40546673229996",
    "40546682470572",
    "40546708324524",
    "40546730737836",
    "40552495284396",
    "40552842002604",
    "40552855371948",
    "40554415849644",
    "40554417455276",
    "40554425516204",
    "41591395451052",
    "41591395451052",
    "41064579629228",
    "41064687665324",
    "41064828436652",
    "41065062793388",
    "41065187672236",
    "41068710985900",
    "41068832915628",
    "41073969299628",
    "41074007900332",
    "41074124161196",
    "41074620006572",
    "41075063259308",
    "41088136282284",
    "41088530251948",
    "41093322408108",
    "41093392498860",
    "41099125194924",
    "41101966803116",
    "41194724556972",
    "41195020222636",
    "41195058725036",
    "41222593183916",
    "41223471693996",
    "41224571617452",
    "41256843804844",
    "41256876769452",
    "41256894300332",
    "41256914026668",
    "41265027481772",
    "41265114316972",
    "41269750268076",
    "41269822914732",
    "42531483386028",
    "42827067130028",
    "42832949280940",
    "42836416463020",
    "42842916585644",
    "42863321252012",
    "42863582904492",
    "42863584215212",
    "41069103874220",
    "41087797723308",
    "42531474702508",
    "42518771957932",
    "42810282442924",
    "41064523727020",
    "41591282991276",
    "41074688000172",
    "41099064377516"
]
const skuToAppendCOD = [
] 

window.checkCODAvailability = function (skuList) {
  let ignoreCOD = false;
  let appendCOD = false;

  if (!Array.isArray(skuList)) {
    return null;
  }

  for (let i = 0; i < skuList.length; i++) {
    const currentSKU = skuList[i];
    if (typeof currentSKU !== "string") {
      return null;
    } else {
      if (skuToIgnoreCOD.includes(currentSKU)) {
        ignoreCOD = true;
      }
    }
  }

  if (skuToAppendCOD.length > 0 && skuList.length > 0) {
    appendCOD = skuList.every((element) => skuToAppendCOD.includes(element));
  }

  if (ignoreCOD) {
    return false;
  }

  if (!ignoreCOD && appendCOD) {
    return true;
  }

  return null;
};
